/**
 * Nocturne subscription teaser (sections/nocturne-saas.liquid): fills the phone mock-up with tonight's
 * real sky for the demo city — the star of the evening, what else is up and when — and a notification
 * for the next telescope event, all from NocturneGuide. Shared by the home teaser and the Nocturne Ciel page
 * (snippets/nx-ciel-phone.liquid).
 */
(() => {
  if (customElements.get('nocturne-sky-demo') || !window.NocturneGuide) return;
  const G = window.NocturneGuide;
  const DAY = 86400000;

  function countdown(t, now) {
    const d = Math.round((new Date(t).setHours(0, 0, 0, 0) - new Date(now).setHours(0, 0, 0, 0)) / DAY);
    if (d <= 0) return 'Aujourd’hui';
    if (d === 1) return 'Demain';
    return `Dans ${d} jours`;
  }

  class NocturneSkyDemo extends HTMLElement {
    connectedCallback() {
      const place = { name: this.dataset.city, lat: parseFloat(this.dataset.lat), lon: parseFloat(this.dataset.lon) };
      // Another town tried on the page (nocturne-ciel.js) redraws the phone for it.
      this.onPlace = (event) => this.render(event.detail);
      document.addEventListener('nx:place', this.onPlace);
      this.render(place);
    }

    disconnectedCallback() {
      document.removeEventListener('nx:place', this.onPlace);
    }

    render(place) {
      if (!Number.isFinite(place.lat) || !Number.isFinite(place.lon)) return;
      const now = Date.now();
      const tonight = G.night(place, 0, now);
      const star = tonight.star;
      this.querySelectorAll('[data-city]').forEach((el) => (el.textContent = place.name));

      if (star) {
        this.querySelector('[data-star-name]').textContent = star.name;
        this.querySelector('[data-star-when]').textContent = `${star.atLabel} ${G.fmt(star.at.t)} · ${G.dir(star.at.az)}`;
      }

      const list = this.querySelector('[data-list]');
      list.replaceChildren();
      for (const item of tonight.items.filter((i) => i !== star).slice(0, 6)) {
        const li = document.createElement('li');
        const dot = document.createElement('i');
        dot.style.setProperty('--dot', item.color || (item.kind === 'moon' ? '#f5f5f7' : '#a5a3ff'));
        const name = document.createElement('b');
        name.textContent = item.name;
        const when = document.createElement('span');
        when.textContent = G.fmt(item.at.t);
        li.append(dot, name, when);
        list.append(li);
      }

      const next = G.events(place, now)[0];
      if (next) {
        const title = next.title.replace(/^(La|Le|Les) /, (m) => m.toLowerCase());
        this.querySelector('[data-toast-text]').textContent = `${countdown(next.t, now)} : ${title}.`;
        this.querySelector('[data-toast]').hidden = false;
      }
    }
  }

  customElements.define('nocturne-sky-demo', NocturneSkyDemo);
})();
